const legacyScriptSrc = '/assets/terapeuta/js/scripts.js';

if (typeof document !== 'undefined' && !document.querySelector(`script[data-terapeuta-legacy="${legacyScriptSrc}"]`)) {
  const script = document.createElement('script');
  script.src = legacyScriptSrc;
  script.defer = true;
  script.dataset.terapeutaLegacy = legacyScriptSrc;
  document.head.appendChild(script);
}

if (import.meta.hot) {
  import.meta.hot.accept(() => {});
}
